import type { KYCQuestionDefinition } from '@anchorage/graphql/generated';
import { parseSanitize } from '@anchorage/utils';
import { FormCheckboxGroup, reactHookForm, useWatch } from '@latitude/form';
import { useEffect, useState } from 'react';

import css from './styles.module.css';

type Props = {
  question: KYCQuestionDefinition;
  isDisabled?: boolean;
  trackFn?: (questionId: string) => void;
};

function CheckboxComponent({
  question,
  isDisabled = false,
  trackFn = () => {},
}: Props) {
  const { control } = reactHookForm.useFormContext();

  // track change
  const [userClicked, setUserClicked] = useState(false);
  const [prevValue, setPrevValue] = useState<string | string[] | undefined>('');
  const selectedOption = useWatch({
    control,
    name: `${question.id}.options`,
  }) as string[] | string;
  useEffect(() => {
    setPrevValue(selectedOption);
    if (!userClicked) {
      return;
    }
    if (selectedOption !== prevValue) {
      trackFn?.(question.id);
    }
  }, [selectedOption, userClicked, question.id, prevValue, trackFn]);

  return (
    <div
      className={css.checkboxesContainer}
      onClick={() => setUserClicked(true)}
    >
      <FormCheckboxGroup
        control={control}
        options={
          question?.options?.map((option) => ({
            label: parseSanitize(option.text) ?? '',
            value: option.id,
            disabled: isDisabled,
            // make all checkboxes align to the top
            wrapperClassname: '!items-start',
          })) || []
        }
        name={`${question.id}.options`}
      />
    </div>
  );
}

export { CheckboxComponent };
